import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import DeleteForever from '@material-ui/icons/DeleteForever';
import { FaEnvelope } from 'react-icons/fa';
import PermissionIconButton from '../../../Button/Permission/IconButton/PermissionIconButton';
import useStyles from './BasicActions.styles';


function BasicActionsTable({
  id,
  nome,
  onEdit,
  onRedefinirSenha,
  onDetails,
  onRemove,
  allows,
  userAllow,
  isCliente,
  isRequisicao = false,
  idRequisicaoPagtoDireto1 = 0,
  idRequisicaoPagtoDireto2 = 0,
  editDisabled,
  isAbaCliente = false,
  isComercial = false,
}) {
  const styles = useStyles();

  return (
    <div className={styles.wrapper}>
      <PermissionIconButton
        idAllow={allows.consultar}
        userAllow={userAllow}
        title="Consultar"
        onClick={() => onDetails(id)}
      >
        <ZoomInIcon />
      </PermissionIconButton>
      {!isRequisicao && (
      <PermissionIconButton
        idAllow={allows.editar}
        userAllow={userAllow}
        title="Editar"
        disabled={isAbaCliente && isComercial && editDisabled !== false}
        onClick={() => onEdit(id)}
      >
        <EditIcon />
      </PermissionIconButton>
      )}
      {isRequisicao && (
      <PermissionIconButton
        idAllow={allows.editar}
        userAllow={userAllow}
        disabled={id === idRequisicaoPagtoDireto1 || id === idRequisicaoPagtoDireto2}
        title="Editar"
        onClick={() => onEdit(id)}
      >
        <EditIcon />
      </PermissionIconButton>
      )}
      {!isRequisicao && (
      <PermissionIconButton
        title="Excluir"
        idAllow={allows.excluir}
        userAllow={userAllow}
        onClick={() => onRemove(id, nome)}
      >
        <DeleteForever />
      </PermissionIconButton>
      )}
      {isRequisicao && (
      <PermissionIconButton
        title="Excluir"
        idAllow={allows.excluir}
        userAllow={userAllow}
        disabled={id === idRequisicaoPagtoDireto1 || id === idRequisicaoPagtoDireto2}
        onClick={() => onRemove(id, nome)}
      >
        <DeleteForever />
      </PermissionIconButton>
      )}
      {isCliente !== undefined && (
        <PermissionIconButton
          title="Redefinir senha"
          idAllow={allows.consultar}
          userAllow={userAllow}
          onClick={() => onRedefinirSenha(id)}
        >
          <FaEnvelope />
        </PermissionIconButton>
      )}
    </div>
  );
}

export default BasicActionsTable;
